  <template
              
            >
              <div v-bar class="vs-scrollable" style="line-height: 2.45; display: flex;">
                <div>
                  <div class="con-exemple-customer-prompt px-4 py-3">
                      <vs-row>
                      <b>{{$t('Service.Table.Id')}}</b> : {{selected.id}}
                    </vs-row>
                    <vs-row>
                      <b>{{$t('Service.Table.Title')}} </b>: {{selected.title}}
                    </vs-row>
                     

                    <vs-row>
                      <b>{{$t('Service.Table.Description')}}</b> : {{selected.description}}
                    </vs-row>


                    <vs-row>
                      <b>{{$t('Service.Table.Industry')}} </b>: {{selected.industry_id}}
                    </vs-row>
                    <vs-row>
                      <b>{{$t('Service.Table.CreatedAt')}}</b> : {{selected.created_at}}
                    </vs-row>

                    <vs-row>
                      <b>{{$t('Service.Table.UpdatedAt')}}</b> : {{selected.updated_at}}
                    </vs-row>
                    <vs-row>
                      <h3><br> Translations </h3>
                    </vs-row>
                    <vs-row>
                      <b>en</b> : {{selected.translations.en}}
                    </vs-row>
                    <vs-row>
                      <b>fr</b> : {{selected.translations.fr}}
                    </vs-row>
                    <vs-row>
                      <b>ar</b> : {{selected.translations.ar}}
                    </vs-row>
                   
                    
                   
                  </div>
                </div>
              </div>

              
</template>

<script>
import { router } from '../../_helpers'
export default {
    name:"ViewService",
    data: () => ({
    title: "",
    lname: "",
    phone_number: "",
    address: "",
    email: "",
    notes: "",
    internalId: "",
    }),
    props:{
        selected : Object
    },
   
    mounted(){


    }
}
</script>
